import React, { PureComponent } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Checkbox } from '@material-ui/core';

interface SubjectPhaseProps {
  subjectPhaseData: any;
}
const grid = 5;
class SubjectPhase extends PureComponent<SubjectPhaseProps> {
  getItemStyle = (isDragging: any, draggableStyle: any) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'grey',

    // styles we need to apply on draggables
    ...draggableStyle,
  });
  render = () => {
    const { subjectPhaseData } = this.props;
    const { name = '', subjectIndex, phaseIndex, weekIndex } = subjectPhaseData;
    return (
      <Droppable droppableId={`subject-${phaseIndex}-${weekIndex}-${subjectIndex}`}>
        {(provided) => (
          <div ref={provided.innerRef}>
            <Draggable
              key={`subject-${phaseIndex}-${weekIndex}-${subjectIndex}`}
              draggableId={`subject-${phaseIndex}-${weekIndex}-${subjectIndex}`}
              index={subjectIndex}
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                >
                  <span style={{ paddingBottom: '10px' }}>{`CH${subjectIndex + 1} ${name}`}</span>
                  {/* <Checkbox /> */}
                </div>
              )}
            </Draggable>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  };
}

export default SubjectPhase;
